import { render, staticRenderFns } from "./PanelContent.vue?vue&type=template&id=4f6c0408&scoped=true&"
import script from "./PanelContent.vue?vue&type=script&lang=ts&"
export * from "./PanelContent.vue?vue&type=script&lang=ts&"
import style0 from "./PanelContent.vue?vue&type=style&index=0&id=4f6c0408&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6c0408",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
